import {
  JbI18nData
} from "./chunk.SE5MQEAG.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  JBCookie
} from "./chunk.WXNWU2SV.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-region-select-overlay/jb-region-select-overlay.scss?inline
var jb_region_select_overlay_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
.region-select-overlay__text {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

.region-select-overlay__text {
  color: rgb(var(--rgb-primary, 20, 30, 85));
  font-size: 1.063rem;
  line-height: 1.875rem;
}
@media (min-width: 1281px) {
  .region-select-overlay__text {
    font-size: 1.188rem;
    line-height: 2.125rem;
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: #141e55;
  display: block;
  min-height: 100%;
  padding-bottom: 112px;
  transform-origin: top center;
  width: 100%;
}

.region-select-overlay {
  background-color: #141e55;
  padding-top: 30px;
}
@media (min-width: 600px) {
  .region-select-overlay {
    padding-top: 0;
  }
}
@media (min-width: 960px) {
  .region-select-overlay {
    padding-top: 50px;
  }
}
@media (min-width: 1281px) {
  .region-select-overlay {
    padding-top: 40px;
  }
}
.region-select-overlay__scroll-wrap {
  min-height: 100%;
}
@media (min-width: 960px) {
  .region-select-overlay__scroll-wrap {
    padding-top: 7vh;
  }
}
.region-select-overlay__wrap {
  opacity: 0;
  padding: 0 25px;
  width: 100%;
}
@media (min-width: 600px) {
  .region-select-overlay__wrap {
    margin-left: auto;
    margin-right: auto;
    max-width: 548px;
    padding: 0;
  }
}
@media (min-width: 960px) {
  .region-select-overlay__wrap {
    padding-bottom: 170px;
  }
}
@media (min-width: 1437px) {
  .region-select-overlay__wrap {
    max-width: 710px;
    width: 45vw;
  }
}
.region-select-overlay__text {
  font-size: 13px;
  font-size: 0.8125rem;
  line-height: 20px;
  line-height: 1.25rem;
  color: #fff;
  margin-bottom: 34px;
}
@media (min-width: 600px) {
  .region-select-overlay__text {
    font-size: 16px;
    font-size: 1rem;
    line-height: 26px;
    line-height: 1.625rem;
  }
}
@media (min-width: 1437px) {
  .region-select-overlay__text {
    font-size: 19px;
    font-size: 1.1875rem;
    line-height: 34px;
    line-height: 2.125rem;
  }
}
.region-select-overlay__notification {
  margin-bottom: 16px;
}

jb-button {
  cursor: pointer;
  --rgb-primary: 255, 255, 255;
}

#region {
  z-index: 3;
}

#country {
  z-index: 2;
}

#language {
  z-index: 1;
}`;

// src/components/jb-region-select-overlay/jb-region-select-overlay.ts
var JbRegionSelectOverlay = class extends Initiable(Linkable(Animatable(h))) {
  constructor() {
    super(...arguments);
    this._alert = "";
    this._countries = [];
    this._countryDisabled = false;
    this._languageDisabled = false;
    this._languages = [];
    this._link = "";
    this._regionDisabled = false;
    this._regions = [];
    this._selectedCountry = JBCookie.getI18nCookieData().country;
    this._selectedLanguage = JBCookie.getI18nCookieData().language;
    this._selectedLanguageIso2 = JBCookie.getI18nCookieData().languageIso2;
    this._selectedMarket = JBCookie.getI18nCookieData().market;
    this._selectedRegion = JBCookie.getI18nCookieData().region || "0";
  }
  firstUpdated() {
    this.loadAllRegions();
    this.loadCountriesForRegion();
    this.addEventListener("jb-select:changed", (event) => {
      const eventDetail = event.detail;
      if (eventDetail.id === "region") {
        this._selectedRegion = eventDetail.newValue;
        this.loadCountriesForRegion();
      }
      if (eventDetail.id === "country") {
        this._selectedCountry = eventDetail.newValue;
        this._selectedMarket = this._countries.find((country) => country.value === eventDetail.newValue)?.market.toString();
        this.loadLanguagesForCountry();
      }
      if (eventDetail.id === "language") {
        this._selectedLanguageIso2 = eventDetail.newValue;
        const languageUid = this._languages.find((language) => language.value === eventDetail.newValue)?.uid;
        this._selectedLanguage = languageUid ? languageUid.toString() : "0";
        this._link = this._languages.find((language) => language.value === eventDetail.newValue)?.url;
      }
    });
  }
  loadAllRegions() {
    const regions = JbI18nData.find()?.getI18nDataRegions();
    if (!regions) {
      return;
    }
    regions.map(
      (region) => this._regions.push({
        label: region.label,
        value: region.regionUid.toString(),
        countries: region.countries,
        regionUid: region.regionUid
      })
    );
  }
  loadCountriesForRegion() {
    const countries = JbI18nData.find()?.getI18nDataCountriesForRegion(this._selectedRegion);
    this._countries = [];
    if (!countries) {
      return;
    }
    countries.map(
      (country) => this._countries.push({
        label: country.label,
        value: country.countryIsoCode.toString(),
        countryIsoCode: country.countryIsoCode.toString(),
        languageOptions: country.languageOptions,
        market: country.market
      })
    );
    this._countryDisabled = countries.length <= 1;
    if (this._countries.length === 1) {
      this._selectedCountry = this._countries[0].value;
    }
  }
  loadLanguagesForCountry() {
    const i18nDataComponent = JbI18nData.find();
    if (!i18nDataComponent) {
      return;
    }
    const languageOptions = i18nDataComponent.getI18nDataLanguageOptionsForCountry(this._selectedCountry);
    this._languages = [];
    if (!languageOptions) {
      return;
    }
    let foundLanguage;
    languageOptions.forEach((languageOption) => {
      const language = i18nDataComponent.getLanguageByIsoCode(languageOption.language);
      if (language?.languageIsoCode === JBCookie.getI18nCookieData().languageIso2) {
        foundLanguage = JBCookie.getI18nCookieData().languageIso2;
      }
      if (!language) {
        return;
      }
      this._languages.push({
        label: language.label,
        value: language.languageIsoCode.toString(),
        uid: language.languageUid,
        url: languageOption.url,
        languageData: language
      });
      if (languageOption.marketAlert?.body) {
        this._alert = languageOption.marketAlert.body;
      } else {
        this._alert = "";
      }
    });
    const newLanguage = foundLanguage ?? this._languages[0]?.value;
    if (newLanguage !== "") {
      setTimeout(() => {
        this._languageSelect.setValue(newLanguage);
        this._selectedLanguageIso2 = newLanguage;
        this._link = this._languages.find((language) => language.value === newLanguage)?.url;
      }, 10);
    }
    this._languageDisabled = languageOptions.length <= 1;
  }
  setCookieAndGAData(e2) {
    this._fireTrackingEvent(e2);
    const newCookieData = {
      country: this._selectedCountry,
      language: this._selectedLanguage,
      languageIso2: this._selectedLanguageIso2,
      market: this._selectedMarket || "",
      region: this._selectedRegion
    };
    JBCookie.setI18nCookieData(newCookieData);
  }
  _fireTrackingEvent(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "header",
      interaction_effect: "update_location",
      interaction_element: "location-selector",
      interaction_text: `location-selector__region:${this._selectedRegion}|country:${this._selectedCountry.toLowerCase()}|language:${this._selectedLanguage}`
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return ke`
      <div class="region-select-overlay">
        <div
          class="region-select-overlay__scroll-wrap"
          data-scroll-lock-scrollable
        >
          <div class="region-select-overlay__wrap">
            <div class="region-select-overlay__text">${this.text}</div>
            <jb-select
              id="region"
              .label=${this.regionLabel}
              .options=${this._regions}
              .value=${this._selectedRegion}
              .disabled=${this._regionDisabled}
              .type=${"isregionselect"}
              showLabel
            ></jb-select>
            <jb-select
              id="country"
              .label=${this.countryLabel}
              .options=${this._countries}
              .value=${this._selectedCountry}
              .disabled=${this._countryDisabled}
              .type=${"isregionselect"}
              showLabel
            ></jb-select>
            <jb-select
              id="language"
              .label=${this.languageLabel}
              .options=${this._languages}
              .value=${this._selectedLanguageIso2}
              .disabled=${this._languageDisabled}
              .type=${"isregionselect"}
              showLabel
            ></jb-select>
            <slot></slot>
            ${this._alert ? ke`
                  <div class="region-select-overlay__text region-select-overlay__notification">
                    <p>${this._alert}</p>
                  </div>
                ` : ""}
            <jb-button
              @jb-link:clicked=${this.setCookieAndGAData}
              .link=${{ href: this._link }}
              .text=${this.buttonText}
            ></jb-button>
          </div>
        </div>
      </div>
    `;
  }
};
JbRegionSelectOverlay.styles = r(jb_region_select_overlay_default);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "buttonText", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "countryLabel", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "languageLabel", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "regionLabel", 2);
__decorateClass([
  n()
], JbRegionSelectOverlay.prototype, "text", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_alert", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_countries", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_countryDisabled", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_languageDisabled", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_languages", 2);
__decorateClass([
  e("#language")
], JbRegionSelectOverlay.prototype, "_languageSelect", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_link", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_regionDisabled", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_regions", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedCountry", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedLanguage", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedLanguageIso2", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedMarket", 2);
__decorateClass([
  r2()
], JbRegionSelectOverlay.prototype, "_selectedRegion", 2);
JbRegionSelectOverlay = __decorateClass([
  customElement("jb-region-select-overlay")
], JbRegionSelectOverlay);

export {
  JbRegionSelectOverlay
};
